define 'controller/AsyncRecommendationController', ['jquery', 'lib/kryptonite'], ($) ->
  class AsyncRecommendationController
    constructor: (@$el) ->
      target = @$el[0]
      area = target.dataset.recoArea
      url = "/recommendation/" + area

      if target.dataset.articleRef
        url = url + "?article=" + target.dataset.articleRef

      if target.dataset.categoryRef
        url = url + "&category=" + target.dataset.categoryRef

      if target.dataset.categoryRef2
        url = url + "&category2=" + target.dataset.categoryRef2

      if target.dataset.categoryRef3
        url = url + "&category3=" + target.dataset.categoryRef3


      $.kryptonite
        url: url
        method: 'get'
        xhrFields:
          showLoadingIndicator: false
    destroy: ->
      @$el.off()
